import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ups-unipin-widget',
  templateUrl: './unipin-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-block w-100 position-relative rounded-lg' 
  }
})
export class UniPinWidgetComponent { }
